export default "__VITE_ASSET__Eu97QtZ1__"